module.exports = __webpack_public_path__ + "img/IEC30478.96910535.png";